import { FC } from "react";
import { useAppSelector } from "@/store/hooks";
import { resourceExplorerGroupingSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/data/resourceExplorerGroupingSelector";
import { resourceExplorerDataGridDataCountSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/data-grid/resourceExplorerDataGridDataCountSelector";
import { resourceExplorerGranularDataCountSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/data-grid/granular-costs-view/resourceExplorerGranularDataCountSelector";
import { resourceExplorerDataGridViewSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/resourceExplorerDataGridViewSelector";
import { resourceExplorerGroupingLabelByGroupingSelector } from "@/store/resource-explorer/selectors/possible-groupings/resourceExplorerGroupingLabelByGroupingSelector";
import { LabelColumnHeaderCell } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/header-cell-components/LabelColumnHeaderCell";

export const BillingExplorerLabelColumnHeaderCell: FC = () => {
  const grouping = useAppSelector(resourceExplorerGroupingSelector);
  const dataGridView = useAppSelector(resourceExplorerDataGridViewSelector);
  const totalDataCount = useAppSelector(
    resourceExplorerDataGridDataCountSelector,
  );
  const groupingsLabel = useAppSelector((state) =>
    resourceExplorerGroupingLabelByGroupingSelector(state, grouping),
  );
  const groupingLabel = groupingsLabel?.singular ?? "";
  const granularDataCount = useAppSelector(
    resourceExplorerGranularDataCountSelector,
  );
  const dataCount =
    dataGridView === "total" ? totalDataCount : granularDataCount;

  return (
    <LabelColumnHeaderCell
      grouping={grouping}
      dataCount={dataCount}
      groupingLabel={groupingLabel}
    />
  );
};
